/* eslint-disable */
import {
  Layout,
  Card,
  Typography,
  Button,
  Space,
  Flex,
  Tabs,
  Spin,
  Modal,
  message,
  Dropdown
} from "antd";

import React, { useEffect, useState, useRef } from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import {
  MenuOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import { dataTo12Fn } from "@/utils/date";
import AddModal from "./component/AddModal";
import EditModal from "./component/EditModal";
const AnnualLeavePage = () => {

  const addModalRef = useRef(null);
  const editModalRef = useRef(null);

  const [activeTab, setActiveTab] = useState("1");

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
const isSickLeave = activeTab === "2";
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });


  const fetchTable = async (page = 1, pageSize = 10, type = activeTab) => {
    setLoading(true);
    try {
      const response = await http.post(api.getRuleList, {
        page,
        count: pageSize,
        type: Number(type),
      });

      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }

      const list = (response?.data?.list || []).map((item, index) => ({
        ...item,
        key: item?.id ?? index,
      }));

      setTableData(list);

      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: response?.data?.total || 0,
      }));

      setSelectedRowKeys([]);
      setSelectedRows([]);
    } catch (err) {
      console.error(err);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTable(1, 10, activeTab);
  }, [activeTab]);


  const showModalAdd = () => {
    addModalRef.current?.setModelAdd(Number(activeTab));
  };

  const handleMenuClick = (e, record) => {
    if (e.key === "Edit") {
      editModalRef.current?.open(record);
    }
  };


  const deleteByIds = (ids = []) => {
    if (!ids.length) return;

    setSubmitLoading(true);
    return http
      .get(api.getRuleDel, { params: { ids: ids.join(",") } })
      .then((res) => {
        if (res?.code === "1") {
          message.success("Deleted successfully.");
          fetchTable(pagination.current, pagination.pageSize);
        } else {
          message.error(res?.msg);
        }
      })
      .finally(() => setSubmitLoading(false));
  };

  const handleBatchDelete = () => {
    if (!selectedRowKeys.length) {
      message.warning("Please select at least one item");
      return;
    }

    Modal.confirm({
      title: "Confirm delete?",
      onOk: () => deleteByIds(selectedRowKeys),
    });
  };


const getColumns = () => {
  const baseColumns = [
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      width: 60,
      render: (text, record) => {
        const menuItems = [
          commonFn.btnAuthorityFlag("Edit") && {
            key: "Edit",
            icon: (
              <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
            ),
            label: <span>Edit View</span>,
          },
        ].filter(Boolean);

        return (
          menuItems.length > 0 && (
            <Dropdown
              menu={{
                items: menuItems,
                onClick: (e) => handleMenuClick(e, record),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{
                  cursor: "pointer",
                  fontSize: 16,
                  color: "#0e78a9",
                }}
              />
            </Dropdown>
          )
        );
      },
    },
    {
      title: "Work Years",
      dataIndex: "workYears",
      width:100,
     hidden: isSickLeave
    },

    {
      title: "Annual Hours",
      dataIndex: "annualHours",
        width:120,
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
        width:180,
      render: (v) => dataTo12Fn(v, 1) || "-",
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
        width:180,
      render: (v) => dataTo12Fn(v, 1) || "-",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      width:250
    },
  ];

  return baseColumns.filter((col) => !col.hidden);
};

  const handleTableChange = (pageInfo) => {
    fetchTable(pageInfo.current, pageInfo.pageSize);
  };

  return (
    <div className="dashboard-layout">     
          <Tabs
            activeKey={activeTab}
            onChange={(key) => {
              setActiveTab(key);
              setPagination({ current: 1, pageSize: 10, total: 0 });
            }}
            items={[
              { key: "1", label: "Annual Leave" },
              { key: "2", label: "Sick Leave" },
            ]}
          />

          <Flex justify="space-between" style={{ marginBottom: 20 }}>
         <Space>
  {commonFn.btnAuthorityFlag("New") && (
    <Button className="btnNew" onClick={showModalAdd}>
      <PlusOutlined />
      New
    </Button>
  )}

  {commonFn.btnAuthorityFlag("Delete") && (
    <Button
      className="btnDEL"
      loading={submitLoading}
      onClick={handleBatchDelete}
    >
      <DeleteOutlined />
      Delete
    </Button>
  )}
</Space>
          </Flex>

          <Spin spinning={loading}>
            <EnhancedTable
            columns={getColumns()}
              dataSource={tableData}
              rowKey="id"
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
              rowSelection={{
                selectedRowKeys,
                onChange: (keys, rows) => {
                  setSelectedRowKeys(keys);
                  setSelectedRows(rows);
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </Spin>


        <AddModal
          ref={addModalRef}
          onSuccess={() => fetchTable(pagination.current, pagination.pageSize)}
        />

        <EditModal
          ref={editModalRef}
          onSuccess={() => fetchTable(pagination.current, pagination.pageSize)}
        />
  
    </div>
  );
};

export default AnnualLeavePage;